import styled from "styled-components";

export const ChipGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const BankChip = styled.div`
  padding: 7px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(244, 241, 242, 0.08);
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
`;

export const SectionLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.45);
`;
